$('#scrollToTop').on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({scrollTop: 0}, 200);
});

$(document).on('click', '.go-back', function (e) {
    e.preventDefault();
    history.back();
});

$(document).on('click', '.print_link', function (e) {
    e.preventDefault();
    window.print();
});

$(document).on('click', '.category-scroll', e => {
    e.preventDefault();
    window.scrollTo({
        top: $(e.currentTarget.hash).offset().top,
        behavior: 'smooth'
    });
});

$(document).on('click', '.back-link', function () {
    history.back();
});


//Fix by default opened accordion elements from ckeditor block
$(".blocks_accordion .accordion .collapse").removeClass("show");
$(".blocks_accordion .accordion .accordion-header")
    .addClass("collapsed")
    .attr("aria-expanded", "false");
$(".blocks_accordion .accordion").css("visibility", "visible").hide().fadeIn(0);


window.onbeforeprint = function () {
    // $('.table-responsive table tbody td').each(function (e) {
    //     if (!$(this).find('.td-title').length) {
    //
    //         var td = $(this);
    //         var th = $(td).closest('table').find('th').eq($(td).index());
    //         var text = $(th).text();
    //
    //         $(this).prepend("<span class='td-title'>" + text + ": </span>");
    //     }
    // });

    $('.tab-print-title').remove();

    $('#nav-tab button').each(function () {
        var tabId = $(this).attr('data-bs-target'); // pvz. "#nav-age"
        var title = $(this).text().trim();
        var $content = $(tabId);

        // Pridedam pavadinimą į turinio pradžią, jei dar nėra
        if ($content.length && !$content.find('.tab-print-title').length) {
            $content.prepend('<div class="tab-print-title">' + title + '</div>');
        }
    });
}

window.addEventListener('afterprint', function () {
    $('.tab-print-title').remove();
});


// Sticky second header
$(function () {
    var $win = $(window);
    var $hdr = $('.second-header');
    if (!$hdr.length) return;

    var $ph = $('<div>').insertBefore($hdr).hide();

    function check() {
        var top = $hdr.data('origTop');
        if (top === undefined) {
            $hdr.removeClass('sticky');
            top = $hdr.offset().top;
            $hdr.data('origTop', top);
        }
        if ($win.scrollTop() >= top) {
            if (!$hdr.hasClass('sticky')) {
                $ph.height($hdr.outerHeight()).show();
                $hdr.addClass('sticky');
            }
        } else {
            if ($hdr.hasClass('sticky')) {
                $ph.hide().height(0);
                $hdr.removeClass('sticky');
            }
        }
    }

    $win.on('scroll resize', check);
    check();
});

// Main page news list
$(function () {
    var $row = $('.make-slick');
    if (!$row.length) return;

    function equalizeSlides() {
        $row.find('.slick-slide').css('height', 'auto');
        var maxH = 0;
        $row.find('.slick-slide').each(function () {
            var h = $(this).outerHeight();
            if (h > maxH) maxH = h;
        });
        if (maxH) $row.find('.slick-slide').css('height', maxH + 'px');
    }

    function start() {
        if ($row.hasClass('slick-initialized')) return;
        $row.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            arrows: false,
            dots: false,
            adaptiveHeight: true
        });

        $row.on('init setPosition reInit', equalizeSlides);
        equalizeSlides();
    }

    function stop() {
        if ($row.hasClass('slick-initialized')) {
            $row.slick('unslick');
            // undo heights we set
            $row.find('.slick-slide').css('height', '');
            $row.off('init setPosition reInit', equalizeSlides);
        }
    }

    function check() {
        if ($(window).width() < 768) start();
        else stop();
    }

    $(window).on('resize', function () {
        clearTimeout(window._t);
        window._t = setTimeout(check, 120);
    });

    check();

    // mobilefilters
    function initMobileFilters() {
        if ($(window).width() < 992) {
            $('.mobile-filters select').each(function () {
                var $select = $(this);

                if (!$select.data('select2')) {
                    $select.select2({
                        dropdownParent: $('.mobile-filters .offcanvas-body')
                    });
                }
            });
        }
    }

    $(window).on('load resize', initMobileFilters);

    //checks if thumbnail img is vertical of horizontal
    $('.news_widget .card-img-top').each(function () {
        const img = this;

        const apply = () => {
            if (img.naturalWidth <= img.naturalHeight) {
                $(img).addClass('is-vertical');
            }
        };

        if (img.complete) {
            apply();
        } else {
            $(img).one('load', apply);
        }
    });
});

$(document).on('click', '.messages-bar__close', function () {
    const $item = $(this).closest('.messages-bar__item');
    const $bar  = $('#messagesBar');

    $item.slideUp(200, function () {
        $(this).remove();

        if (!$bar.find('.messages-bar__item').length) {
            $bar.fadeOut(150, function () {
                $(this).remove();
            });
        }
    });
});

function updateStickyOffset() {
    var firstHeaderHeight = $('.first-header').outerHeight() || 0;
    var secondHeaderHeight = $('.second-header').outerHeight() || 0;

    var offset = firstHeaderHeight + secondHeaderHeight;

    $('.sticky-side-top').css({
        position: 'sticky',
        top: offset + 'px'
    });
}

$(document).ready(updateStickyOffset);
$(window).on('resize', updateStickyOffset);


$(function () {

    $('.table-rounded-wrapper .table-responsive').each(function () {

        const table = $(this);

        if (!table.parent().hasClass('table-scroll-wrap')) {
            table.wrap('<div class="table-scroll-wrap"></div>');
            table.before('<div class="table-scroll-top"><div></div></div>');
        }

        const wrap = table.parent();
        const topScroll = wrap.find('.table-scroll-top');
        const inner = topScroll.find('div');

        function syncWidths() {
            inner.width(table[0].scrollWidth);
            checkScroll();
        }

        function checkScroll() {
            const el = table[0];
            const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
            wrap.toggleClass('is-end', atEnd);
        }

        syncWidths();

        topScroll.on('scroll', function () {
            table.scrollLeft($(this).scrollLeft());
            checkScroll();
        });

        table.on('scroll', function () {
            topScroll.scrollLeft($(this).scrollLeft());
            checkScroll();
        });

        $(window).on('resize', syncWidths);

    });
});